import { gql } from '@/utilities/gql';

import type { ResultOf, VariablesOf } from '@/utilities/gql';

import { makeGqlMutation } from '@/utilities/gqlQuery';

const MUTATION = gql(`
  mutation updateTransactionPortfolio($id: String!, $transactions: [ManualTransactionInput!]!) {
    updateTransactionPortfolio(id: $id, transactions: $transactions) {
      id
    }
  }
`);

export type Transactions = VariablesOf<typeof MUTATION>['transactions'];

const mutation = makeGqlMutation(MUTATION);

interface Props {
  onSuccess?: (data: ResultOf<typeof MUTATION>) => void;
}

export const useUpdateTransactionPortfolio = ({ onSuccess }: Props = {}) => {
  return mutation({
    onSuccess,
  });
};
